import { useEffect, useState } from 'react';
import { Operation } from '@/backend/models/operation';
import { I18n } from '@/i18n/I18n';
import { useTreeStore } from '@/frontend/store/TreeStore';

export function NotesItemRun(props: { initItem: Operation }) {
  const { initItem } = props;
  const [value, setValue] = useState(initItem.content || '');
  const updateOperation = useTreeStore(state => state.updateOperation);

  useEffect(() => {
    setValue(initItem.content || '');
  }, [initItem.content]);

  const onBlur = async () => {
    await updateOperation({ 
      operation: { ...initItem, content: value }, 
      hideToast: true 
    });
  };

  const onChangeContent = (content: string) => {
    setValue(content);
  };

  return (
    <div className="pt-1">
      <div className="form-floating">
        <textarea
          className="form-control form-control-sm"
          id={`content-${initItem.id}`}
          onChange={(e) => onChangeContent(e.target.value)}
          onBlur={() => void onBlur()}
          value={value}
          name='notes-content'
          placeholder={I18n.get('notesPlaceholder')}
          rows={3}
        />
        <label htmlFor={`content-${initItem.id}`}>
          <small>{I18n.get('notes')}</small>
        </label>
      </div>
    </div>
  );
}
